require('dropify')

import{
    trans,
    PRZECIAGNIJ_I_UPUSC,
    PRZECIAGNIJ_I_UPUSC_LUB_KLIKNIJ,
    USUN,
    WYSTAPIL_BLAD,


} from '../../../translator';
export function dropifyInit(selector)
{

    if (!$().dropify()) {
        console.warn('Warning - select2.min.js is not loaded.');
        return
    }

    $(selector).dropify({
        messages: {
            'default': trans(PRZECIAGNIJ_I_UPUSC),
            'replace': trans(PRZECIAGNIJ_I_UPUSC_LUB_KLIKNIJ),
            'remove':  trans(USUN),
            'error':   trans(WYSTAPIL_BLAD),
        },
        error: {
            'fileSize': 'The file size is too big ({{ value }} max).',
            'minWidth': 'The image width is too small ({{ value }}}px min).',
            'maxWidth': 'The image width is too big ({{ value }}}px max).',
            'minHeight': 'The image height is too small ({{ value }}}px min).',
            'maxHeight': 'The image height is too big ({{ value }}px max).',
            'imageFormat': 'The image format is not allowed ({{ value }} only).'
        }
    })

}